import { render, staticRenderFns } from "./GaleryView.vue?vue&type=template&id=08daf456"
import script from "./GaleryView.vue?vue&type=script&lang=js"
export * from "./GaleryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports